export default __webpack_public_path__ + "static/media/GANESH.5ea22e26.png";